import React, {FC, useCallback, useMemo, useState} from 'react';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import classNames from 'classnames';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import EnsurePermission from '../common/EnsurePermission';
import LinkRenderer from './LinkRenderer';
import {useLocation} from 'react-router-dom';
import {ListItemProps} from './types';

type NavBarSubmenuItemProps = {
  label: string,
  submenu: ListItemProps[],
  permissions?: Nullable<string[]>,
  closeDrawer: () => void,
}

const getInitialVisibility = (submenu, pathname) => {
  const routes = submenu.map(({route}) => route);

  return routes.some((route) => new RegExp(route || '').test(pathname));
};

const NavBarSubmenuItem: FC<NavBarSubmenuItemProps> = ({
  submenu, permissions, label, closeDrawer
}) => {
  const {pathname} = useLocation();

  const initialVisibility = useMemo(() =>
    getInitialVisibility(submenu, pathname),
  [submenu, pathname]
  );

  const [visible, setVisible] = useState(initialVisibility);

  const manageSubmenuVisibility = useCallback(() => {
    setVisible((prevState) => !prevState);
  }, []);

  return (
    <EnsurePermission elementPermissions={permissions}>
      <ListItemButton
        onClick={manageSubmenuVisibility}
        className={classNames('list-item-button submenu-button', {'active': visible})}
      >
        <ListItemIcon className="submenu-icon">
          <ArrowRightIcon className="submenu-icon-arrow" />
        </ListItemIcon>
        <div className="">{label}</div>
      </ListItemButton>

      <Collapse in={visible} unmountOnExit>
        <List className="navbar__list-submenu">
          {submenu.map(({
            route,
            permissions: menuItemPermissions,
            label: menuItemLabel,
            exact
          }) => (
            <EnsurePermission
              key={route}
              elementPermissions={menuItemPermissions}
            >
              <ListItemButton className="list-item-button submenu-list-item">
                <LinkRenderer
                  exact={exact}
                  label={menuItemLabel}
                  route={route}
                  closeDrawer={closeDrawer}
                />
              </ListItemButton>
            </EnsurePermission>
          ))}
        </List>
      </Collapse>
    </EnsurePermission>
  );
};

export default NavBarSubmenuItem;
